import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

import styles from './styles.css'

momentDurationFormatSetup(moment)

const NOTE_STATUS = {
  1: 'Unopened',
  2: 'Opened',
  3: 'Resolved',
  4: 'Archived',
}

const StatusDot = ({ style, status }) => {
  let statusColor
  switch (status) {
    case 1:
      statusColor = 'rgba(219, 61, 59, 1)'
      break
    case 2:
      statusColor = 'rgba(237, 224, 109, 1)'
      break
    case 3:
      statusColor = 'rgba(27, 153, 104, 1)'
      break
    default:
      statusColor = 'rgba(117, 119, 128, 1)'
  }
  return <i style={{ color: statusColor, ...style }} className="fa fa-circle" />
}

class ListCard extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    sentDate: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    noteStatus: PropTypes.number.isRequired,
    onExpandCard: PropTypes.func.isRequired,
    onDeleteCard: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  onExpandCard = () => {
    const { onExpandCard, id } = this.props
    onExpandCard(id)
  }

  onDeleteCard = e => {
    e.stopPropagation()

    const { onDeleteCard, id } = this.props
    onDeleteCard(id)
  }

  render() {
    const { name, email, status, sentDate, subject, noteStatus } = this.props
    return (
      <div className={styles.cardContainer} onClick={this.onExpandCard}>
        <div className={styles.statusIconContainer}>
          <StatusDot status={status} style={{ fontSize: 25 }} />
        </div>
        <div className={styles.nameEmailContainer}>
          <div style={{ fontSize: 18, color: 'white', marginBottom: 3, flex: 0.4 }}>{name}</div>
          <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', flex: 0.6 }}>{email}</div>
        </div>
        <div className={styles.subjectDateContainer}>
          <div
            style={{ fontSize: 18, color: 'white', marginBottom: 3, flex: 0.4 }}
          >{`Subject: ${subject}`}</div>
          <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', flex: 0.6 }}>{`Sent ${moment(
            sentDate
          ).format('MMM do')} | ${NOTE_STATUS[noteStatus]}`}</div>
        </div>
        <div onClick={this.onDeleteCard}>
          <i className={classnames('fa fa-trash', styles.icon)} />
        </div>
      </div>
    )
  }
}

export default ListCard



// WEBPACK FOOTER //
// ./src/views/collaborate/sent-message-panel/list-card/index.js